<tc-room-add-card
        [roomTypeOptions]="roomTypeOptions"
        [selectedRooms]="selectedRooms"
        (closeModal)="closeModal($event)">
</tc-room-add-card>